import React from "react";
import MainLayout from "../../../hoc/main";
import {Dropdown, FormContainer, Grid, Input} from "../../../components";
import {connect} from "react-redux";
import {addReceptionistDeviceData} from "../../../redux/modules/ReceptionistDevice/action";
import {Button} from "../../../components/Button";
import {Redirect} from "react-router-dom";
import {getBardiDatas} from "../../../redux/modules/Bardi/action";

class ReceptionistDeviceAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            chargerId: "",
            UNUM: "",
        };
    }

    componentDidMount() {
        this.props.getBardiDatas();
    }

    onChangeValue = (e) => {
        const {value, name} = e.target;

        this.setState({
            [name]: value,
        });
    };

    onChangeCheckBox = (e) => {
        const {checked, name} = e.target;
        this.setState({
            [name]: checked,
        });
    };

    finishForm(e) {
        e.preventDefault();
        this.props.addReceptionistDeviceData(this.state);
    }

    render() {
        if (this.props.receptionistDevice?.success) return <Redirect to="/receptionist-device"/>;
        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <FormContainer className={`pt-0`}>
                        <Input
                            name={"name"}
                            label={"ReceptionistDevice name"}
                            value={this.state.name}
                            placeholder={"Lorem"}
                            className={"w-full md:w-1/2 xl:w-1/3"}
                            onChange={this.onChangeValue}
                        />
                        <Input
                            name={"UNUM"}
                            label={"Device UNUM"}
                            value={this.state.UNUM}
                            placeholder={"XX:XX:XX:XX:XX"}
                            className={"w-full md:w-1/2 xl:w-1/3"}
                            onChange={this.onChangeValue}
                        />
                        <Dropdown
                            label={"Charger"}
                            data={this.props.bardi.datas.result}
                            expectedValue={"id"}
                            display={"name"}
                            name={"chargerId"}
                            value={this.state.chargerId}
                            onChange={this.onChangeValue}
                            placeholder="Choose one category"
                        />

                        <hr className={`my-5`}/>
                        <Button
                            className={`bg-green-200 text-green-700`}
                            onClick={this.finishForm.bind(this)}
                        >
                            Submit
                        </Button>
                    </FormContainer>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    receptionistDevice: state.receptionistDevice,
    bardi: state.bardi,
});

const mapDispatchToProps = {
    addReceptionistDeviceData,
    getBardiDatas,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(ReceptionistDeviceAdd)
);
